export enum SharePointTag {
  FileName = 'FileName',
  Mixin = 'Mixin',
  SiteName = 'SiteName'
}

export const SharePointTagsMap = new Map<SharePointTag, { tag: string; prop: string; value?: Record<string, string> }>([
  [SharePointTag.Mixin, { tag: 'Folder/File of site', prop: 'SiteName' }],
  [SharePointTag.SiteName, { tag: 'Site name', prop: 'Name' }],
  [SharePointTag.FileName, { tag: 'Folder/File name', prop: 'Name' }]
]);
